import React from 'react'
import Banner from './Banner'
import JobSlider from './JobSlider'
import Faqs from './Faqs'
import ClientReviews from './ClientReviews'
import Blogs from './Blogs'

const Home = () => {
  return (
    <div className='bigscreen'>
      <Banner/>
      <JobSlider/>
      <ClientReviews/>
      <Blogs/>
      <Faqs/>
    </div>
  )
}

export default Home
